<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3ISkNl/tc-custom/9781452132204.jpg?1705026024094" alt="This image is the cover for the book Commando Dad: A Basic Training Manual for the First Three Years of Fatherhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Commando Dad: A Basic Training Manual for the First Three Years of Fatherhood
      </h1>
      <p class="bookDescription body article font2">
        <b>An indispensable training manual for new recruits to fatherhood—written by an ex-Commando and dad of three.</b><br/><br/><i>Commando Dad</i> provides clear and logical advice on all the practicalities of becoming a new father and offers simple, helpful instruction for all obstacles along the way. Neil Sinclair teach prospective fathers, in no-nonsense terms, how to survive the first twenty-four hours; how to Prepare and Plan to Prevent Poor Parental Performance; how to maintain morale in the ranks; how to feed, clothe, transport, and entertain your troops; how to transport the troops successfully on maneuvers; how to increase your “flash to bang” time and “square away” tasks along the way.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Neil Sinclair
      </h2>
      
      <p class="authorDescription body article">Neil Sinclair has been a Royal Engineer Commando, a physical education teacher, and a licensed childcare provider. He is a full-time dad living in London, England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f2e2929